import Bowser from 'bowser'
import { useMemo } from 'react'

export const useDeviceDetection = () => {
  return useMemo(() => {
    const browser = Bowser.getParser(window.navigator.userAgent)
    const osName = browser.getOSName().toLowerCase()
    const isSafari = browser.isBrowser('Safari')
    const isChrome = browser.isBrowser('Chrome')
    const browserName = browser.getBrowserName()

    // Checks if the device has a touch screen since ipads and macOS have identical agent strings
    // iPads report 5 touch points; Macs report 0 (or rarely 1 via simulators)
    const hasTouch = (navigator.maxTouchPoints || 0) > 2
    const isIOS = osName === 'ios' || (osName === 'macos' && hasTouch)
    // Additionally some Android tablets such as Samsung Tabs report their OS as Linux, so we the same trick here
    // Note: This WILL falsely detect the user as being on Android if they're on a Linux laptop with a touchscreen.
    const isAndroid = osName === 'android' || (osName === 'linux' && hasTouch)

    return {
      isIOS,
      isAndroid,
      isSafari,
      isChrome,
      browserName,
      browser,
    }
  }, [])
}
